import {HttpService} from '../HttpService';

class AuthenticationService {
    getTransferInfo(nonce) {
        return new Promise((resolve, reject) => {
            try {
                const svc = HttpService.createWithoutAuthorization();
                svc.callApiAnonymously('GET', `/login/oauth/${nonce}`)	//todo: add this resource to api
                    .then(result =>  resolve(result.data),
                        err => reject(err));
            }catch (error) {
                reject(error);
            }
        });
    }
}

const svc = new AuthenticationService();

export default svc;

